import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Amerikansk fodbold",
    Baseball: "Baseball",
    Basketball: "Basketball",
    Boxing: "Boksning",
    Chess: "Skak",
    Cricket: "Cricket",
    Darts: "Dart",
    Entertainment: "Entertainment",
    "E-Sports": "E-Sports",
    Football: "Fodbold",
    "Formula 1": "Formel 1",
    "Gaelic Football": "Gælisk fodbold",
    "Generic Sport": "Generic Sport",
    Golf: "Golf",
    "Greyhound Racing": "Greyhound Racing",
    Handball: "Håndbold",
    "Ice Hockey": "Ishockey",
    IndyCar: "IndyCar",
    MMA: "MMA",
    Nascar: "Nascar",
    Politics: "Politics",
    "Rugby League": "Rugby Liga",
    "Rugby Union": "Rugby Union",
    Snooker: "Snooker",
    "Table Tennis": "Bordtennis",
    Tennis: "Tennis",
    "Virtual Football": "Virtual Football",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} for at vinde",
    WinFirstRound: "{name} for at vinde første runde",
    FirstTouchdown: "{name} for at score en touchdown først",
    FirstTry: "{name} for at score et Prøv først",
    TotalGoals: "{name} Samlede mål",
    TotalRuns: "{name} Runs i alt",
    TotalPoints: "{name} Samlet point",
    TopBatsman: "{name} til at være Top Batsman",
    TopBowler: "{name} til at være Top Bowler",
    FirstScore: "{name} for at score først"
  },
  PromoTexts: {
    Pick: "Lav dine valg",
    Bet: "Væddemål",
    Pays: "Udbetaling"
  },
  DateTimeTexts: {
    Today: "I dag",
    Tomorrow: "I morgen",
    Live: "Direkte"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Lav dine valg",
    Return: "Udbetaling",
    Stake: "Væddemål",
    Draw: "X"
  },
  H2HTexts: {
    goals_scored: "Scoringer",
    shots: "Skud",
    shots_on_target: "Skud på mål",
    ball_possession: "Boldkontrol",
    goals_conceded: "Mål indkasseret",
    "Per match": "Pr. kamp",
    H2H: "Vertaile",
    W: "S",
    D: "U",
    L: "T",
    T: "U",
    // baseball
    runs_per_game: "Runs",
    runs_allowed_per_game: "Runs Allowed",
    hits_per_game: "Hits",
    batting_average: "AVG",
    on_base_percentage: "OBP",
    slugging_percentage: "SLG",
    home_runs: "HR",
    stolen_bases: "SB",
    earned_run_average: "ERA",
    walks_hits_per_inning_pitched: "WHIP",
    strikeouts_per_9_innings: "K/9",
    homeruns_allowed_per_game: "HR",
    batting_average_against: "BA",
    batting_stats: "Batting/Running",
    pitching_stats: "Pitching/Defence",

    // american football
    points_per_game: "Points",
    points_allowed_per_game: "Points Allowed",
    rushing_stats: "Rushing Stats",
    rushing_yards_per_game: "Rushing Yards",
    rushing_touchdowns: "Rushing Touchdowns (total)",
    rushing_percentage: "Rushing %",
    passing_stats: "Passing Stats",
    passing_yards_per_game: "Passing Yards",
    passing_touchdowns: "Passing Touchdowns (total)",
    passing_percentage: "Passing %"
  }
};
